import {SendConfigToUser} from "../../../Hooks/Api/sendConfigToUser";
import Lottie from "react-lottie";
import downloadAnimations from "../../Lottie/download.json";
import React, {useRef, useState} from "react";
import {useHaptic} from "../../../Hooks/useHaptic";
import {UIButtons} from "../ProMode";

export const DownloadConfig = (
    {
        protocolId,
        config,
    }
) => {
    const [isDownloadConfigBtn, setDownloadConfigBtn] = useState(false);
    const [isPlayingDownloadCfg, setIsPlayingDownloadCfg] = useState(false);
    const downloadLottieRef = useRef(null);
    const handleAnimationCompleteDownloadBtn = () => {
        setTimeout(() => setIsPlayingDownloadCfg(false), 200)
    };

    const {hapticFeedBack} = useHaptic("success")

    return (
            <UIButtons disabled={isDownloadConfigBtn} onClick={() => {
                SendConfigToUser(protocolId, config)
                hapticFeedBack()
                setIsPlayingDownloadCfg(true);
                setDownloadConfigBtn(true)
            }}
            >
                <Lottie
                    style={{width: "unset", margin: 0}}
                    height={30}
                    isStopped={!isPlayingDownloadCfg}
                    isPaused={false}
                    ref={downloadLottieRef}
                    options={{
                        loop: false,
                        autoplay: false,
                        animationData: downloadAnimations,
                    }}
                    eventListeners={[
                        {
                            eventName: "complete",
                            callback: handleAnimationCompleteDownloadBtn,
                        },
                    ]}
                />
            </UIButtons>
    )
}